































import { Component, Prop, Vue } from 'vue-property-decorator';
import Equation from '@/components/Equation.vue';
import { SustainedTurnConstraint } from '@/interfaces/constraints';

@Component({
  components: {
  Equation,
  }
  })
export default class SustainedTurnFields extends Vue {
  @Prop() constraint!: SustainedTurnConstraint;
}
